import * as Yup from 'yup';

import { FiLock, FiLogIn, FiMail } from 'react-icons/fi';
import { Link, useHistory } from 'react-router-dom';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';

import { AnimationContainer, BackgroundVideo } from './styles';
import { Form as BootForm } from 'react-bootstrap';
import Button from '../../components/Button';
import DefaultMasterPage from '../../masterpages/DefaultMasterPage';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import Input from '../../components/Input';
import Languages from '../../components/Languages';
import getValidationErrors from '../../utils/getValidationErrors';
import queryString from 'query-string';
import { useAuth } from '../../hooks/FirebaseAuth';
import { useEvent } from '../../hooks/EventContext';
import { useToast } from '../../hooks/Toast';
import { useTranslation } from 'react-i18next';

interface SignInFormData {
  email: string;
  password: string;
}

// TODO: can we make this better?
const reactIcons = {
  FiLock, FiLogIn, FiMail
} as any;

const SignIn: React.FC = (props: any) => {
  const { t, i18n } = useTranslation();
  const formRef = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);
  const { integration, signIn, signOut, getUser } = useAuth();
  const user = getUser();
  const { addToast } = useToast();
  const history = useHistory();
  const eventContext = useEvent();
  const [terms, setTerms] = useState({ term: true, share: 'yes' });

  // if (user && user.id) {
  //   history.replace(`/${props.params.event}/dashboard`);
  // }

  let token = "";

  if (window.location.search.indexOf('?token') > -1) {
    token = window.location.search.replace('?token=', '');
  }

  if (window.location.search.indexOf('?string') > -1) {
    token = window.location.search.replace('?string=', '');
  }

  if (window.location.search) {
    const params = queryString.parse(props.location.search);
    if (params.id) {
      token = JSON.stringify({
        name: params.name,
        id: params.id
      });
    }
  }

  useEffect(() => {
    if (token) {
      integration({ token, eventKey: props.params.event });
    }

    return () => { }
  }, [token, props.params.event])

  const handleSubmit = useCallback(
    async (data: SignInFormData) => {
      try {
        formRef.current?.setErrors({});

        //TODO: ADICIONADO PARA FACBPS 2023 TEMPORARIAMENTE
        // const validNumbers = [
        //   '60005009634', '04466555117', '01218746645', '07044472745', '30147257816', '02164668308', '07819892722', '18469017829', '15194877897', '12068133857', '90117689068', '91864844000', '28927230191', '04537989858', '32092321803', '07383164822', '11292691670', '17156721860', '49091310006', '16693923844', '60228202191', '15752914876', '05155204704', '14118333848', '31321078838', '64607429600', '15231343803', '77262042300', '07095258856', '03880877300', '10206071736', '21011630397', '00673846091', '01383588856', '47804815620', '68599315749', '11110254873', '04491329940', '98765432101', '11976482674', '52989770810', '63923963815', '03292301904', '07763373946', '42852096838', '27894887897', '10769613713', '24885566886', '03145240889', '06536076877', '1160386838', '14791260805', '22699309400', '07210637729', '00709316909', '02738246940', '25998895886', '40952481812', '00322381851', '81227191804', '42461421072', '00269957006', '16867608841', '92977219072', '22000727832', '12333532840', '21904414800', '11833884620', '00361049650', '00773836993', '31295610809', '31431898864', '36355730869', '02050972784', '31645789896', '11909217824', '95608214900', '33269372884', '69654689200', '31374054836', '32044792850', '66916216891', '05491126420', '11958118885', '82277249149', '00699003881', '52377342191', '08769283869', '17520560864', '22904356860', '14277365884', '07596956793', '18602371772', '08332998832', '04914255626', '18468598836', '48403687087', '03377662154', '08234125710', '02295012490', '77040490382', '48341440032', '74782525087', '29806063830', '89116186168', '27606806810', '00336528990', '22958442829', '31321568843', '29862278803', '25909104870', '97409693720', '03419137907', '08070676876', '10090123808', '42067449800', '32306979871', '01422845729', '27144448811', '30763129879', '16508437801', '09541593739', '37500809840', '42792348844', '04327973866', '71590137604', '27372508894', '06325595866', '72657847153', '10662749839', '68371078013', '68082908653', '01450880819', '00939880016', '43093060630', '61006343849', '71245804634', '05779028494', '07920598591', '07036597666', '33520463873', '00517340879', '27227170772', '02513521706', '07604978770', '53385797071', '76841456815', '30569501806', '00095249087', '83593110725', '50408456000', '10006460410', '66072867804', '07753161806', '56511256120', '36672960880', '69371571187', '00776994832', '05291628731', '15115064820', '07660795112', '37842539898', '32153480809', '01062911148', '74740660334', '75244870963', '15700965895', '08214184754', '04788695766', '05553947600', '91909554049', '04285836793', '08951067602', '46007514854', '35889905856', '49188720691', '27756651871', '86166921853', '06098828644', '65045998900', '27343573802', '24361658072', '33735887821', '19637727841', '91013941691', '01377532682', '93854790759', '15748443845', '12974725864', '00489510728', '17331895800', '25851053852', '30139548840', '00022417907', '22710041871', '74202553934', '19716430841', '15551520668', '60054541379', '13773483856', '02853138607', '59655372715', '94881979000', '03956619862', '03831444935', '10161877427', '53701798087', '74541501872', '12959192737', '25117357841', '18137651896', '32554074860', '13106671793', '02996315839', '44075154068', '07648705729', '11677468807', '06334407600', '83305726504', '02416659731', '60383542634', '49287583668', '11608426718', '03090126435', '03384655885', '69199434091', '17377598883', '07999233706', '95265198687', '12141369665', '20845758853', '00514425822', '31874657220', '29501761860', '68992629834', '64058697920', '32248282850', '56602244078', '10586946691', '11601387881', '04772649808', '36937533004', '67390765704', '96183780049', '02778202943', '13228932842', '09012578779', '31301934801', '26626883860', '36732733885', '07454770460', '32366610890', '12432672755', '00366240803', '26163331800', '34320118812', '32569813800', '19744970898', '03233716800', '47721936934', '00347017614', '12343002738', '81036477800', '08460055817', '29525695840', '09578697708', '11638258830', '05850551905', '60451700163', '02813846651', '04363316837', '11988869862', '04470168904', '34583808844', '56995032187', '17317856827', '86044575853', '00031066755', '73570338053', '07633227842', '36363138000', '11941083854', '08341645823', '08197515883', '50684434504', '04943196829', '75018730706', '14777730883', '91917620900', '04204652867', '27126226500', '71463356153', '53092066634', '06755851809', '26517716866', '26507422835', '58415556268', '44604187894', '66456908868', '61032301287', '91111498849', '47299118149', '19862943823', '03106576871', '13486022873', '39539008115', '01347166122', '87624265168', '77450205734', '51171244487', '04132970981', '32591086885', '88112926034', '00452966850', '55990010834', '36897474819', '03582505600', '15261271053', '08192274632', '23679786034', '14275765800', '29998907888', '34548989862', '10366848810', '19476777800', '21548074888', '11440877750', '03053673908', '01126565105', '39389317878', '17650471888', '07561863829', '01341466116', '08789508696', '34424514854', '17429860800', '79668763149', '06088372885', '06919822954', '37947835810', '27386982801', '00654076286', '99937522153', '74079670672', '31339945819', '05897943966', '72764040059', '01673334377', '03366088028', '52672743991', '32275121811', '09145831904', '09590950710', '02405441969', '04247205820', '17704987968', '07043389984', '15652732814', '33103443803', '24836126878', '12484003722', '02789991820', '40655024700', '96457988334', '17787057823', '16582025899', '07463611817', '69540527872', '10308957830', '30474738892', '04565388871', '07956265843', '29209742893', '01033399906', '06315338933', '04223618954', '36878890845', '01550849174', '09861511814', '34437867823', '13794189841', '25506368801', '07054169921', '80400515172', '12432250761', '74422308734', '04488872824', '03722235162', '06492760948', '19494050878', '85394947015', '40650680880', '21903240840', '02311541862', '30152199870',
        //   '21441736808', '47054186893', '01817802240',
        //   '16807300893', '31101204885', '27314541809', ' 03667270879', '26797155860', '16005868802', '36018630818', '45073154843', '11912923807', '48335671800', '05338706156', '17258981870', '30152199870', '30347672850', '70566720191', '28986336820', '17258977848', '36861770809', '04543031652', '33442151830', '82897468149', '01426813007', '01814377913', '84024739387', '34626563848', '63977419668', '26163331800'
        // ];


        // const schema = Yup.object().shape({
        //   email: Yup.string()
        //     .required(t('Login is required'))
        //     .oneOf(validNumbers, t('Login is required'))
        // });

       
        const schema = Yup.object().shape({
          email: Yup.string().required(t('Login is required'))
        });

        // TODO: remove try
        try {
          // TODO: make enum
          if (eventContext?.event?.settings?.login?.type === "number") {
            // clean password, if it should be a number
            data.email = data.email.replace(/[\. ,:-]+/g, "");
          }
        } catch { }

        await schema.validate(data, {
          abortEarly: false,
        });

        setLoading(true);

        // await signIn({
        //   email: `${props.params.event}:${data.email}`,
        //   password: data.password
        // });

        await signIn({
          email: data.email,
          password: data.password,
          eventKey: props.params.event,
          share: terms.share === 'yes',
          term: terms.term
        });

        //document.location.href = `/${props.params.event}/`;
      } catch (error) {
        const err: any = error;
        //TODO: DESCOMENTAR
        //   if (error instanceof Yup.ValidationError) {
        //     const errors = getValidationErrors(error);

        //     formRef.current?.setErrors(errors);
        //     return;
        //   }
        //   setLoading(false);
        //   addToast({
        //     type: 'error',
        //     title: 'Erro na autenticaçāo',
        //     description: error?.response?.data?.message || error.message || t('An error occurred while registering, please try again'),
        //   });
        // }

        //TODO: TEMP FACPCS
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRef.current?.setErrors(errors);

          addToast({
            type: 'error',
            title: 'CPF não encontrado ou permitido',
            description: 'Entre em contato com o suporte',
          });
          return;
        }
        setLoading(false);
        addToast({
          type: 'error',
          title: 'Erro na autenticaçāo',
          description: err?.response?.data?.message || err.message || t('An error occurred while registering, please try again'),
        });
      }
    },
    [signIn, addToast, history, terms],
  );

  const emailIcon = eventContext?.event?.settings?.login?.icons?.email;

  //TODO: RETIRAR ASSSIM QUE ACABAR O EVENTO FACPS2023

  const validNumbers = ['14275765800', '29998907888', '34548989862'];

  const schema = Yup.object().shape({
    email: Yup.string()
      .required('Login é obrigatório')
      .oneOf(validNumbers, 'O número deve ser um dos seguintes: 14275765800, 29998907888, 34548989862'),
    password: Yup.string().required('Senha é obrigatória'),
  });

  return (
    <DefaultMasterPage {...props}>
      {/* <div id="customizationlogin" dangerouslySetInnerHTML={{ __html: eventContext.event?.customization?.customHtmlLogin }}></div> //! Denys comentou */}

      {/*  DIV LOGIN BACKGROUND   */}
      {/* <div id="loginbackground" dangerouslySetInnerHTML={{ __html: eventContext.event?.customization?.customLoginBackground }}></div> //! Denys comentou */}



      {!token && <>
        {/* {props.params.event === 'minervaday25' && (
          <BackgroundVideo autoPlay muted loop playsInline id="background-video">
            <source src="https://firebasestorage.googleapis.com/v0/b/antonicelli-official.appspot.com/o/companies%2Fevento_teste_hypera%2Fcustomization%2F149e30a2-a4a6-461b-9e9f-39d93362dbe1?alt=media&token=0def096d-accf-4a3b-b622-bd9a0ea5cdca" type="video/mp4" />
          </BackgroundVideo>
        )} */}
        <AnimationContainer>
        <Form className="form signin-form" ref={formRef} onSubmit={handleSubmit}>

          <div className="pre-signin-access-your-account"></div>
          <h1 className="signin-access-your-account">{eventContext?.event?.settings?.texts?.loginTitle || t('Access your account')}</h1>

          <div className="pre-signin-languages"></div>
          <Languages></Languages>

          <Input type={eventContext?.event?.settings?.login?.type || "text"} name="email" icon={emailIcon ? reactIcons[emailIcon] : (eventContext?.event?.settings?.login?.title ? FiLogIn : FiMail)} placeholder={eventContext?.event?.settings?.texts?.loginInput || eventContext?.event?.settings?.login?.title[i18n.language] || eventContext?.event?.settings?.login?.title || t('Email')} />
          {!eventContext?.event?.settings?.noLogin && <Input
            name="password"
            icon={FiLock}
            type="password"
            placeholder={t('Password')}
          />}



          {!!eventContext?.event?.settings?.login?.termsEnabled && <div style={{ textAlign: 'center' }}>
            <div className="term-uso" style={{ padding: '20px', fontSize: '12px', marginBottom: '0', color: 'white' }}>
              {t('Do you accept the terms of use of the platform?')}
              <div className='term-uso-checkbox' >
                <input name={`term`} type="checkbox" checked={terms.term} onChange={(e) => { setTerms({ ...terms, term: e.target.checked }); }} /> <span className="term-text">{t('Yes')}</span> {!!eventContext?.event?.settings?.login?.termsFile && <span className="term-text">(<a className="term-link" target="_blank" style={{ display: 'inline', color: 'white' }} href={eventContext?.event?.settings?.login?.termsFile}>{t('Click here to read the terms')}</a>)</span>}
              </div>
            </div>
          </div>}

          {/* {!!eventContext?.event?.settings?.login?.termsEnabled && <div style={{ textAlign: 'center' }}>
            <div style={{ padding: '20px', fontSize: '9px', marginBottom: '0' }}>
              Você permite o compartilhamento dos seus dados com os patrocinadores e parceiros do evento?<br /><br />
              <BootForm.Check style={{ display: 'inline' }}
                onChange={(e: any) => { setTerms({ ...terms, share: "yes" }); }}
                onClick={(e: any) => { setTerms({ ...terms, share: "yes" }); }}
                custom
                inline
                checked={terms.share === 'yes'}
                type="radio"
                label="Sim"
                name="share"
                id="share1"
                value="yes"
              />
              <BootForm.Check style={{ display: 'inline' }}
                onChange={(e: any) => { setTerms({ ...terms, share: "no" }); }}
                onClick={(e: any) => { setTerms({ ...terms, share: "no" }); }}
                custom
                inline
                checked={terms.share === 'no'}
                type="radio"
                label="Não"
                name="share"
                id="share2"
                value="no"
              />
            </div>
          </div>} */}

          <div className="pre-signin-enter"></div>
          {(!eventContext?.event?.settings?.login?.termsEnabled || terms.term) && <Button className="signin-enter" loading={loading} type="submit">{t('signin')}</Button>}

          <div className="pre-signin-forgot-password"></div>
          {!eventContext?.event?.settings?.noLogin && <Link className="link signin-forgot-password" to={`/${props.params.event}/forgot-password`}>{eventContext?.event?.settings?.texts?.loginForgotPassword || t("Forgot password")}</Link>}

          <div className="pre-signin-signup"></div>
          {!eventContext?.event?.settings?.noLogin && <Link className="link signin-signup" to={`/${props.params.event}/signup`}>
            {eventContext?.event?.settings?.texts?.loginSignUp || t('Create a new account')}
          </Link>}

          <br />
          <div style={{ paddingLeft: "20%", paddingRight: "20%", marginTop: "15px" }}>
            {eventContext?.event?.settings?.texts?.homeFooter}
          </div>

          {!!eventContext.event?.customization?.signInImg && <img style={{ paddingTop: 30 }} src={eventContext.event?.customization?.signInImg}></img>}
        </Form>
        <div className='footer-login'></div>
      </AnimationContainer></>}
    </DefaultMasterPage>
  );
};

export default SignIn;
